import React from "react";

import SearchFormField from "../../../../../@whitespace/gatsby-plugin-search/src/components/SearchFormField";

PostsModuleFilterFormFields.propTypes = {};

export default function PostsModuleFilterFormFields() {
  return (
    <>
      <SearchFormField param="tags" />
    </>
  );
}
